/**
 * @fileoverview added by tsickle
 * Generated from: visionics/ng/src/app/login/login.module.ts
 * @suppress {checkTypes,constantProperty,extraRequire,missingOverride,missingReturn,unusedPrivateMembers,uselessCode} checked by tsc
 */
import { CommonModule } from "@angular/common";
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { FormsModule } from "@angular/forms";
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularJsModule } from '../angularjs/angular-js.module';
import { FullScreenCardComponent } from "./full-screen-card.component";
import { LoginEmailComponent } from "./login-email.component";
import { LoginRoutingModule } from "./login-routing.module";
import { LoginComponent } from "./login.component";
import { LoginService } from "./login.service";
import * as i0 from "@angular/core";
export class LoginModule {
}
LoginModule.decorators = [
    { type: NgModule, args: [{
                imports: [
                    LoginRoutingModule,
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule,
                    HttpClientModule,
                    AngularJsModule,
                    MatButtonModule,
                    MatCardModule,
                    MatFormFieldModule,
                    MatInputModule,
                ],
                declarations: [
                    FullScreenCardComponent,
                    LoginComponent,
                    LoginEmailComponent,
                ],
                providers: [
                    LoginService,
                ],
            },] },
];
/** @nocollapse */ LoginModule.ɵmod = i0.ɵɵdefineNgModule({ type: LoginModule });
/** @nocollapse */ LoginModule.ɵinj = i0.ɵɵdefineInjector({ factory: function LoginModule_Factory(t) { return new (t || LoginModule)(); }, providers: [
        LoginService,
    ], imports: [[
            LoginRoutingModule,
            CommonModule,
            ReactiveFormsModule,
            FormsModule,
            HttpClientModule,
            AngularJsModule,
            MatButtonModule,
            MatCardModule,
            MatFormFieldModule,
            MatInputModule,
        ]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(LoginModule, { declarations: [FullScreenCardComponent,
        LoginComponent,
        LoginEmailComponent], imports: [LoginRoutingModule,
        CommonModule,
        ReactiveFormsModule,
        FormsModule,
        HttpClientModule,
        AngularJsModule,
        MatButtonModule,
        MatCardModule,
        MatFormFieldModule,
        MatInputModule] }); })();
/*@__PURE__*/ (function () { i0.ɵsetClassMetadata(LoginModule, [{
        type: NgModule,
        args: [{
                imports: [
                    LoginRoutingModule,
                    CommonModule,
                    ReactiveFormsModule,
                    FormsModule,
                    HttpClientModule,
                    AngularJsModule,
                    MatButtonModule,
                    MatCardModule,
                    MatFormFieldModule,
                    MatInputModule,
                ],
                declarations: [
                    FullScreenCardComponent,
                    LoginComponent,
                    LoginEmailComponent,
                ],
                providers: [
                    LoginService,
                ],
            }]
    }], null, null); })();
//# sourceMappingURL=data:application/json;base64,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